import { Avatar, Stack, Typography } from '@mui/material';
import { IDepartment, ISubject } from 'API/UniversalRequest/universalRequest';
import { useIsDesktop } from 'Hooks';
import { TAB_VALUE_TYPE } from 'Modules/UniversalRequest';

interface ISubjectListItem {
  category: ISubject | IDepartment;
  onClick: () => void;
  svgIcon: string;
  tabValue: TAB_VALUE_TYPE;
}

export const ParentCategoriesListItem = ({
  category,
  onClick,
  svgIcon,
  tabValue,
}: ISubjectListItem) => {
  const isDesktop = useIsDesktop();

  const RemunerationOfficersCategoryId = 4;
  const isRemunerationOfficers =
    tabValue === TAB_VALUE_TYPE.DEPARTMENT &&
    category.id === RemunerationOfficersCategoryId;

  let remunerationOfficers = {
    title: '',
    subTitle: '',
  };
  if (isRemunerationOfficers) {
    const titles = category.title.split(' (');
    titles[1] = '(' + titles[1];
    remunerationOfficers.title = titles[0];
    remunerationOfficers.subTitle = titles[1];
  }

  return (
    <Stack
      width={isDesktop ? '274px' : '159px'}
      height={isDesktop ? '150px' : '128px'}
      alignItems='center'
      bgcolor='white'
      boxShadow='0px 4px 16px rgba(8, 30, 84, 0.12)'
      border='1px solid #B7CCFF'
      borderRadius='10px'
      sx={{ cursor: 'pointer' }}
      onClick={onClick}
      textAlign='center'
      p={isDesktop ? '0 76px' : '0 26px'}
      tabIndex={0}
      role='button'
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
    >
      {
        <Avatar
          src={svgIcon}
          alt=''
          sx={{
            mt: isDesktop ? '20px' : '10px',
            width: '48px',
            height: '48px',
          }}
        />
      }
      {isRemunerationOfficers ? (
        <Stack>
          <Typography
            fontSize={isDesktop ? '24px' : '18px'}
            fontWeight='700'
            lineHeight='24px'
            mt={isDesktop ? '12px' : '6px'}
            width='100%'
          >
            {remunerationOfficers.title}
          </Typography>
          <Typography variant='body6'>
            {remunerationOfficers.subTitle}
          </Typography>
        </Stack>
      ) : (
        <Typography
          fontSize={isDesktop ? '24px' : '18px'}
          fontWeight='700'
          lineHeight='24px'
          mt={isDesktop ? '12px' : '6px'}
        >
          {category.title}
        </Typography>
      )}
    </Stack>
  );
};
